<div class="invalid-invitation">
  <app-panel>
    <div class="invalid-card">
      <div class="hero">
        <div class="mark">
          <i
            class="dx-icon dx-svg-icon"
            [innerHTML]="getLinkIcon()"
          ></i>
        </div>

        <h2>{{ 'MY-INVITATION.INVALID-INVITATION.TITLE' | translate }}</h2>

        <p>
          {{ 'MY-INVITATION.INVALID-INVITATION.DESCRIPTION' | translate }}
        </p>
      </div>

      <div class="body">
        <div>
          <div class="section-label">
            {{ 'MY-INVITATION.INVALID-INVITATION.WHAT-YOU-CAN-DO' | translate }}
          </div>

          <div class="steps">
            <div
              class="step"
              *ngFor="let step of steps; let i = index"
            >
              <span class="step-number">
                {{ i + 1 }}
              </span>

              <span
                class="step-text"
                [innerHTML]="step | translate"
              ></span>
            </div>
          </div>
        </div>

        <div class="hint-box">
          <span class="info">
            <i
              class="dx-icon dx-svg-icon"
              [innerHTML]="getInfoIcon()"
            ></i>
          </span>
          <p 
            class="hint"
            [innerHTML]="'MY-INVITATION.INVALID-INVITATION.HINT' | translate"
          ></p>
        </div>

        <div class="support">
          {{ 'MY-INVITATION.INVALID-INVITATION.SUPPORT' | translate }}
        </div>
      </div>
    </div>
  </app-panel>
</div>